import sfs from './sfs';
import efs from './efs';

const schools = { sfs, efs };
const id = process.env.GATSBY_SCHOOL_ID || 'sfs';

export default schools[id] || schools.sfs;
